import React, { useState, useEffect } from "react";
import PrivacyModal from "../../src/HomePage/PrivacyModal";
import "../scss/Scss/Home.scss";
import facebook from "../scss/Icon/facebook-app-symbol.svg";
import instagram from "../scss/Icon/instagram.svg";
import linkedin from "../scss/Icon/linkedin.svg";
import { firestore } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

function Footer() {
  const [data, setData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const docRef = doc(firestore, "CI WEB", "Home");
    const fetchData = async () => {
      try {
        const docSnapshot = await getDoc(docRef);
        if (docSnapshot.exists()) {
          setData(docSnapshot.data());
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };
    fetchData();
  }, []);

  const handlePrivacyClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {data && (
        <div className="Footer">
          <div className="Privacy" onClick={handlePrivacyClick}>
            © crimson and indigo · Privacy Policy
          </div>
          <div className="Social">
            <a
              href="https://www.facebook.com/crimsonandindigo/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={facebook}
                alt="facebook"
                className="IconFacebook"
                loading="lazy"
              />
            </a>

            <a
              href="https://www.instagram.com/crimsonandindigo/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={instagram}
                alt="instagram"
                className="IconInstagram"
                loading="lazy"
              />
            </a>

            <a
              href="https://th.linkedin.com/company/crimson-and-indigo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={linkedin}
                alt="linkedin"
                className="IconLinkedin"
                loading="lazy"
              />
            </a>
          </div>

          <PrivacyModal
            showModal={showModal}
            handleCloseModal={handleCloseModal}
          />
        </div>
      )}
    </>
  );
}

export default Footer;
